import React, { useEffect, useState } from 'react';
import '../styles/InactivityWarningModal.css';

interface InactivityWarningModalProps {
  isOpen: boolean;
  onExtendSession: () => void;
  onLogout: () => void;
  warningDuration: number; // Duration in milliseconds
}

export const InactivityWarningModal: React.FC<InactivityWarningModalProps> = ({
  isOpen,
  onExtendSession,
  onLogout,
  warningDuration
}) => {
  const [timeLeft, setTimeLeft] = useState(warningDuration / 1000); // Convert to seconds

  useEffect(() => {
    if (!isOpen) {
      setTimeLeft(warningDuration / 1000);
      return;
    }

    // Reset timer when modal opens
    setTimeLeft(warningDuration / 1000);

    // Countdown timer
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, warningDuration, onLogout]);

  // Format time as MM:SS
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  if (!isOpen) return null;

  return (
    <div className="inactivity-modal-overlay">
      <div className="inactivity-modal">
        <h2 className="inactivity-modal-header">Er du her?</h2>
        
        <div className="inactivity-modal-content">
          <p className="inactivity-modal-text">Vi logger dig ud om</p>
          <div className="inactivity-modal-countdown">
            {formatTime(timeLeft)}
          </div>
        </div>

        <div className="inactivity-modal-buttons">
          <button 
            className="inactivity-modal-button primary"
            onClick={onExtendSession}
          >
            Ja, jeg er her
          </button>
          <button 
            className="inactivity-modal-button secondary"
            onClick={onLogout}
          >
            Log ud
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
